module.exports = __webpack_public_path__ + "static/media/moi.19d8365e.jpg";